import React from 'react'
import styled from 'styled-components'

import { Translate } from '@hozana/intl/Translate'
import { IMAGE_SIZES } from '@hozana/styling/image'

import { Button } from 'elements/button/Button'
import { Container } from 'elements/layout/Container'
import { Span } from 'elements/layout/Span'
import { VariableHeightImage } from 'elements/media/VariableHeightImage'
import { P } from 'elements/text/P'

import { Popin } from 'general/managers/popins/Popin'
import { TPopinComponent } from 'general/managers/popins/types'
import { TLocale } from 'i18n/constants'

import { PARTNER, POPIN_CTA } from '../constants'
import { getPartnerLink, getPopinId, getPopinIds } from '../functions'
import { TGuide } from '../types'

const RosarioImage = '/img/guides/rosario-popin.jpg'
const MeditatioImage = '/img/guides/meditatio-popin.jpg'

const IMAGES = {
  [PARTNER.ROSARIO]: {
    src: RosarioImage,
    alt: 'trans:guide:guide.popin.image-alt.rosario',
  },
  [PARTNER.MEDITATIO]: {
    src: MeditatioImage,
    alt: 'trans:guide:guide.popin.image-alt.meditatio',
  },
}

const StyledImage = styled(VariableHeightImage)`
  border-radius: 10px;
`

const StyledUl = styled.ul`
  padding: 20px 0;
`

export type TGuideRosarioMeditatioPopinOptions = {
  partner: PARTNER
  guideName: string
  id: number
  locale: TLocale
  idSuffix: number
} & Pick<TGuide, 'slug'>

export const GuideRosarioMeditatioPopin: TPopinComponent<TGuideRosarioMeditatioPopinOptions> = ({
  options: { partner, slug, guideName, id, locale, idSuffix },
}) => (
  <Popin
    h="auto"
    noScroll
    borderRadius="10px"
    fullScreen={false}
    m="1em"
    hidden
    onClose={() => undefined} // Display the close button. full-ssr-functions will attach an event listener
    returnArrow={false}
    w="600px"
    ids={getPopinIds(idSuffix)}
  >
    <Container p="50px 25px 25px">
      <StyledImage src={IMAGES[partner].src} size={IMAGE_SIZES.community.big} alt={IMAGES[partner].alt} />
      <P color="darkBlue" bold fontSize="1.7em" p="1em 0 0">
        <Translate components={{ yellow: <Span key="guideTitle" color="yellow"></Span> }}>
          {partner === PARTNER.MEDITATIO
            ? 'trans:guide:guide.popin.title.meditatio'
            : 'trans:guide:guide.popin.title.rosario'}
        </Translate>
      </P>
      <StyledUl>
        <li>
          {partner === PARTNER.MEDITATIO ? (
            <>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.meditatio.line1
              </P>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.meditatio.line2
              </P>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.meditatio.line3
              </P>
            </>
          ) : (
            <>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.rosario.line1
              </P>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.rosario.line2
              </P>
              <P fontSize="1em" p="5px">
                trans:guide:guide.popin.rosario.line3
              </P>
            </>
          )}
        </li>
      </StyledUl>
      <Button
        id={getPopinId(POPIN_CTA, idSuffix)}
        colors="yellow"
        valueLink={{
          to: getPartnerLink(partner, slug, guideName, id, locale),
          target: '_blank',
          noReferrer: true,
        }}
        size="big"
        w={1}
      >
        trans:guide:guide.popin.cta
      </Button>
    </Container>
  </Popin>
)
